import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { Spin } from 'antd';

const ProtectedRoute = ({ children, roles = [] }) => {
  const { currentUser, isAuthenticated, loading, token } = useContext(AuthContext);
  
  // Global loading
  if (loading) {
    console.debug('[ProtectedRoute] loading...', { path: window.location.pathname });
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  // Not authenticated -> go to login
  if (!isAuthenticated()) {
    console.debug('[ProtectedRoute] not authenticated -> redirect to /login', { path: window.location.pathname, tokenPresent: Boolean(token), currentUser });
    return <Navigate to="/login" replace state={{ from: window.location.pathname }} />;
  }

  // Authenticated by token but user not hydrated yet -> wait
  if (isAuthenticated() && !currentUser) {
    console.debug('[ProtectedRoute] authenticated but currentUser not ready -> waiting', { path: window.location.pathname, tokenPresent: Boolean(token) });
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  // Role check (normalize to lowercase)
  const userRole = (currentUser?.role || '').toLowerCase();
  console.debug('[ProtectedRoute] role check', { path: window.location.pathname, userRole, requiredRoles: roles });
  if (roles.length > 0 && !roles.map(r => r.toLowerCase()).includes(userRole)) {
    const defaultPath = userRole === 'superadmin'
      ? '/dashboard/superadmin'
      : userRole === 'agency'
        ? '/dashboard/agency'
        : userRole === 'client'
          ? '/dashboard/client'
          : userRole === 'whitelabel_agency'
            ? '/dashboard/whitelabel'
            : '/login';
    console.debug('[ProtectedRoute] role mismatch -> redirect to defaultPath', { path: window.location.pathname, userRole, requiredRoles: roles, defaultPath });
    return <Navigate to={defaultPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
